import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

interface TitleActionProps {
  children: React.ReactNode;
}

const TitleAction: React.FC<TitleActionProps> = ({ children }) => {
  const [slot, setSlot] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setSlot(document.getElementById('layout-action-slot'));
  }, []);

  if (!slot) return null;
  return createPortal(<>{children}</>, slot);
};

export default TitleAction;
